import 'react-app-polyfill/ie11';
import 'core-js/features/array';
import 'core-js/features/number';
import 'core-js/features/object/entries';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'typeface-montserrat';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';

import { persistor, store } from 'shared/redux/configureStore';
import { theme } from '@snsw/react-component-library';
import { ThemeProvider } from 'styled-components';
import { PersistGate } from 'redux-persist/integration/react';
import { Header, Footer } from '@onegov/react-component-library';
import './App.css';
import { PasswordlessOidcProvider } from 'shared/oidc/PasswordlessOidcProvider';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import { IdleTimer } from 'shared/components/idleTimer/IdleTimer';

const footerConfig = {
  helpNumber: '13 77 88',
  helpForm: 'https://www.service.nsw.gov.au/contact-us',
  footerLinks: [
    {
      label: 'Accessibility',
      link: 'https://www.service.nsw.gov.au/accessibility',
    },
    {
      label: 'Privacy',
      link: 'https://www.service.nsw.gov.au/privacy',
    },
    {
      label: 'Terms of use',
      link: 'https://www.service.nsw.gov.au/terms-use',
    },
    {
      label: 'Copyright and disclaimer',
      link: 'https://www.service.nsw.gov.au/copyright-and-disclaimer',
    },
    {
      label: 'Accessing information',
      link: 'https://www.service.nsw.gov.au/accessing-information',
    },
    {
      label: 'NSW Government',
      link: 'https://www.nsw.gov.au',
      external: true,
    },
  ],
};

ReactDOM.render(
  <Router basename={process.env.REACT_APP_URL_PREFIX}>
    <Provider store={store}>
      <PasswordlessOidcProvider store={store} userManager={UserPasswordlessManager.instance()}>
        <>
          <Header />
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
              {/* timeout 10 minutes and 5 minutes after prompting */}
              <IdleTimer timeout={10 * 60 * 1000} promptTimeout={5 * 60 * 1000} />
              <App store={store} />
            </ThemeProvider>
          </PersistGate>
          <Footer config={footerConfig} />
        </>
      </PasswordlessOidcProvider>
    </Provider>
  </Router>,
  document.getElementById('root'),
);
